function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M7.286 21c-.354 0-.657-.147-.908-.44A1.574 1.574 0 016 19.5v-8.417c0-.48.147-.893.44-1.236.294-.342.647-.514 1.06-.514h1.929V2.75c0-.233.088-.417.264-.55a.958.958 0 01.593-.2h3.428c.22 0 .417.067.593.2a.652.652 0 01.264.55v6.583h2.143c.354 0 .657.147.908.441.252.294.378.647.378 1.06V19.5c0 .413-.126.766-.378 1.06-.252.293-.554.44-.908.44 0 .283-.082.52-.246.712a.773.773 0 01-.61.288.773.773 0 01-.612-.288A1.057 1.057 0 0115 21H9c0 .283-.082.52-.246.712a.773.773 0 01-.611.288.773.773 0 01-.61-.288A1.057 1.057 0 017.285 21zm3-11.667h3.428V3h-3.428v6.333zm-3 10.167h9.428v-8.667H7.286V19.5zm1.5-1.5h.857v-5.667h-.857V18zm2.785 0h.858v-5.667h-.858V18zm2.786 0h.857v-5.667h-.857V18z"
  }));
};
const SvgCarryOnBag = styled(BaseComponent).withConfig({
  displayName: "CarryOnBag__SvgCarryOnBag",
  componentId: "sc-ou9gqr-0"
})(["outline:none;"]);
SvgCarryOnBag.isIcon = true;
SvgCarryOnBag.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgCarryOnBag;